import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainButton from "./MainButton";
import { AlertTriangle } from "lucide-react";

const NotFound = ({ titleKey = "notFound.title", descKey = "notFound.description" }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-center min-h-[60vh] px-4">
            <div className="w-full max-w-md p-10 text-center border shadow-xl rounded-2xl bg-bg-light-secondary dark:bg-bg-dark-secondary border-border-light dark:border-border-dark">

                <AlertTriangle className="w-16 h-16 mx-auto mb-4 text-red-500" />

                <h1 className="mb-2 text-3xl font-bold text-black dark:text-white">
                    404
                </h1>

                <h2 className="mb-3 text-lg font-semibold text-black dark:text-white">
                    {t(titleKey)}
                </h2>

                <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
                    {t(descKey)}
                </p>

                <MainButton onClick={() => navigate("/")}>
                    {t("notFound.backHome")}
                </MainButton>
            </div>
        </div>
    );
};

export default NotFound;
